export default __webpack_public_path__ + "static/media/evar.74689050.svg";